import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store'
import './plugins/element.js'
import './assets/css/icon.css'
import './assets/css/style.scss'
import Config from './config/app'
import {
    CookiesClear,
    CookiesGet,
    CookiesPut,
    CookiesRemove,
    isLogin,
    removeToken,
    SessionClear,
    SessionGet,
    SessionPut,
    SessionRemove,
    setToken
} from './utils/dataStorage'

Vue.prototype.$setToken = setToken;
Vue.prototype.$isLogin = isLogin;
Vue.prototype.$removeToken = removeToken;
Vue.prototype.$SessionPut = SessionPut;
Vue.prototype.$SessionGet = SessionGet;
Vue.prototype.$SessionClear = SessionClear;
Vue.prototype.$SessionRemove = SessionRemove;
Vue.prototype.$CookiesClear = CookiesClear;
Vue.prototype.$CookiesGet = CookiesGet;
Vue.prototype.$CookiesPut = CookiesPut;
Vue.prototype.$CookiesRemove = CookiesRemove;
Vue.prototype.$Config = Config;

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')






